import { resolveApiBaseUrl } from '../contexts/AuthContext';

/** Stessa API del login e del resto della palestra. I social restano su getSocialApiBaseUrl. */
export function getEmailApiBaseUrl() {
  return String(resolveApiBaseUrl()).replace(/\/$/, '');
}

/** Upload immagine per editor campagne email (URL assoluto HTTPS nel corpo HTML). */
export async function uploadEmailCampaignImage(file) {
  const base = getEmailApiBaseUrl();
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('auth_token') : null;
  const form = new FormData();
  form.append('image', file);

  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(`${base}/gym_email_media_upload.php`, {
    method: 'POST',
    headers,
    body: form,
  });

  let data = {};
  try {
    data = await res.json();
  } catch {
    data = {};
  }

  if (!res.ok) {
    const err = new Error(data.error || 'Upload immagine non riuscito');
    err.response = { data, status: res.status };
    throw err;
  }

  return data;
}

/** Un solo PDF allegato alla campagna (max 5 MB). */
export async function uploadEmailCampaignPdf(file) {
  const base = getEmailApiBaseUrl();
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('auth_token') : null;
  const form = new FormData();
  form.append('pdf', file);

  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(`${base}/gym_email_media_upload.php`, {
    method: 'POST',
    headers,
    body: form,
  });

  let data = {};
  try {
    data = await res.json();
  } catch {
    data = {};
  }

  if (!res.ok) {
    const err = new Error(data.error || 'Upload PDF non riuscito');
    err.response = { data, status: res.status };
    throw err;
  }

  return data;
}
